import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = 'flix_seller_token';
export const SELLER_ID_KEY = 'flix_seller_id';

export const getToken = () => localStorage.getItem(TOKEN_KEY) || '';
export const setSession = (token, seller) => {
  localStorage.setItem(TOKEN_KEY, token);
  if (seller?.id) localStorage.setItem(SELLER_ID_KEY, seller.id);
};
export const clearSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(SELLER_ID_KEY);
};

export const sellerApi = axios.create({ baseURL: API });
sellerApi.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const isReady = (s) => !!(s && s.charges_enabled && s.card_payments_active && s.transfers_active);
